import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import apiData from 'Lib/apiData';
import AccountDetailGridRow from '../account/account-detail-grid-row';
import TablePagination from './table-pagination';

export default class Table extends Component {

  static propTypes = {
    dataEndpoint: PropTypes.string.isRequired,
    dataParams: PropTypes.object,
    dataFormat: PropTypes.func.isRequired,
    submitCount: PropTypes.number,
  }

  static defaultProps = {
    dataParams: {},
    submitCount: 0,
  }

  state = {
    data: null,
    status: 'loading',
  }

  componentDidMount() {
    this.getTableData();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.submitCount !== this.props.submitCount) {
      this.getTableData();
    }
  }

  getTableData = (params = {}, endpoint = this.props.dataEndpoint, setLoading = true) => {
    const { dataParams } = this.props;

    if (setLoading) {
      this.setState({ status: 'loading' });
    }

    apiData(endpoint, { ...params, ...dataParams })
      .then((data) => {
        this.setState({
          data,
          status: null,
        });
      })
      .catch((err) => {
        if (err.response) {
          this.setState({
            status: err.response.message,
          });
        }
      });
  }

  paginateTable = (url) => {
    if (!this.state.data) return;

    this.getTableData({}, url, false);
  }

  render() {
    const { status, data } = this.state;
    const limit = (this.props.dataParams && this.props.dataParams.limit) || 5;
    const loaderRows = Array(limit).fill('row');

    if (this.props.debug) {
      console.log(data); // eslint-disable-line no-console

      return null;
    }

    return (
      <div>
        {status === 'loading' &&
          loaderRows.map((r, i) => (
            // eslint-disable-next-line react/no-array-index-key
            <LoaderRow key={`${r}${i}`} />
          ))
        }
        {!status && data.items.length &&
          <Fragment>
            {this.props.dataFormat(data.items).map(row => (
              <AccountDetailGridRow data={row.data} key={row.id} />
            ))}
            <TablePagination
              paginateTable={this.paginateTable}
              paging={this.state.data.paging}
            />
          </Fragment>
        }
      </div>
    );
  }
}

const LoaderRow = styled.div`
  position: relative;
  width: 100%;
  height: 75px;
  border-bottom: 1px solid #515151;

  &::after {
    content: "";
    position: absolute;
    top: 30px;
    right: 0;
    bottom: 30px;
    left: 0;
    background: linear-gradient(
      to right,
      #24292b 32%,
      transparent 32%,
      transparent 36%,
      #24292b 36%,
      #24292b 60%,
      transparent 60%,
      transparent 64%,
      #24292b 64%,
      #24292b 84%,
      transparent 84%,
      transparent 88%,
      #24292b 88%,
      #24292b
    );
  }
`;
